export const MERIT_COMPANY_NAME = "Merit International, Inc.";
export const MERIT_COMPANY_SHORT_NAME = "Merit";
